<template>
    <div id="div-register-passkey" style="margin: 0 auto; background: #fff; padding: 30px;">
        <RegisterPasskeyContentCommon/>

        <div class="row justify-content-center">
            <div class="col-sm-6 col-md-5 col-xl-4 mb-2">
                <button class="btn btn-primary w-100" @click="clickRegisterButton()">
                    <span>パスキーを登録する</span>
                </button>
            </div>
            <div class="col-sm-6 col-md-5 col-xl-4 mb-2">
                <button class="btn btn-default w-100" @click="clickRegisterLatterButton()">
                    <span>後で設定する</span>
                </button>
            </div>
        </div>
    </div>
</template>

<script>
    import RegisterPasskeyContentCommon from '@/views/passkey/RegisterPasskeyContentCommon'
    import IConstants from '@/common/constants/IConstants';
    import ServiceUtils from "@/common/utils/ServiceUtils";
    import ModalPlugin from "@/common/plugins/ModalPlugin.js";

    import {createNamespacedHelpers} from "vuex";

    const {mapActions: mapNewsActions} = createNamespacedHelpers('news');

    export default {
        name: "RegisterPasskey",
        mixins: [],
        components: {RegisterPasskeyContentCommon},
        data() {
            return {}
        },
        validations() {
            return {}
        },
        computed: {},
        mounted() {
            this.listenEvents()
        },
        beforeDestroy() {
            this.unListenEvents()
        },
        methods: {
            ...mapNewsActions(['actionNeedRegisterPasskey', 'actionHideTopMenu']),
            clickRegisterButton() {
                if (ServiceUtils.isFidoAuthenticateUnsupported()) return this.$modal.showFidoAuthenticateUnsupported()

                this.$service
                    .getService(IConstants.SERVICE_NAME.FIDO)
                    .initRegisterPasskey()
                    .then(async (res) => {
                        if (res.errorMessage) return this.finishRegisterPasskey(false)

                        let credential = await navigator.credentials.create(ServiceUtils.genMakeCredentialRequestV1(res))
                        if (!credential) return this.finishRegisterPasskey(false);

                        let requestPayload = {
                            customerId: res.customerId,
                            fidoUserId: res.fidoUserId,
                            fidoRegistrationId: res.fidoRegistrationId,
                            fidoRegistrationChallengeId: res.fidoRegistrationChallengeId,
                            authProviderName: ServiceUtils.detectSelectedAuthenticator(credential),
                            w3cMakeCredentialResponse: ServiceUtils.genW3cMakeCredentialResponse(credential)
                        }
                        this.$service
                            .getService(IConstants.SERVICE_NAME.FIDO)
                            .registerPasskey(requestPayload, {headers: {'Content-Type': 'application/json'}})
                            .then((res) => {
                                this.finishRegisterPasskey(!ServiceUtils.hasValue(res.errorMessage))
                            })
                    })
                    .catch((e) => {
                        if (ServiceUtils.isUserCancelOrTimeoutPasskeyAction(e)) return;
                        if (ServiceUtils.isDeviceNotSupportPasskey(e)) return this.$modal.showFidoAuthenticateUnsupported();
                        this.finishRegisterPasskey(false)
                    })
                    .finally(() => {
                    })
            },
            listenEvents() {
                ModalPlugin.EventBus.$on(this.IConstants.EVENT_NAME.RETRY_REGISTER_PASSKEY_RESULT, (params) => {
                    if (String(params.retry) === 'true') this.clickRegisterButton()
                    else this.clickRegisterLatterButton()
                });
                ModalPlugin.EventBus.$on(this.IConstants.EVENT_NAME.CLOSE_REGISTER_PASSKEY_SUCCESS, () => {
                    this.$root.$emit(IConstants.EVENT_NAME.ON_CONFIRM_AGREEMENT_WEBKIT);
                    this.actionNeedRegisterPasskey(false);
                    this.actionHideTopMenu(true);
                    this.$router.push({name: "home"})
                });
            },
            unListenEvents() {
                ModalPlugin.EventBus.$off(this.IConstants.EVENT_NAME.RETRY_REGISTER_PASSKEY_RESULT);
                ModalPlugin.EventBus.$off(this.IConstants.EVENT_NAME.CLOSE_REGISTER_PASSKEY_SUCCESS);
            },
            finishRegisterPasskey(result) {
                const params = {result: result};
                this.$modal.showRegisterPasskeyResult(params);
            },
            async clickRegisterLatterButton() {
                await this.$service
                    .getService(IConstants.SERVICE_NAME.FIDO)
                    .registerPasskeyLatter()
                    .then(() => {
                        this.$root.$emit(IConstants.EVENT_NAME.ON_CONFIRM_AGREEMENT_WEBKIT);
                        this.actionNeedRegisterPasskey(false);
                        this.actionHideTopMenu(true);
                        this.$router.push({name: "home"})
                    })
            }
        }
    }
</script>

<style scoped>
    .dot-item {
        font-size: .4em;
        color: black;
        margin-left: 3px;
        margin-right: 10px;
    }

    .mb-2rem {
        margin-bottom: 2rem;
    }

    #div-register-passkey {
        background: #fff;
        padding: 30px;
        margin: 0 auto;
        border: 1px solid #ddd;
        border-radius: 4px;
    }

    @media (max-width: 575px) {
        #div-register-passkey {
            width: 90%;
            margin-top: 15px !important;
        }
    }

    @media (min-width: 576px) {
        #div-register-passkey {
            width: 500px;
            margin-top: 15px !important;
        }
    }

    @media (min-width: 768px) {
        #div-register-passkey {
            width: 700px;
            margin-top: 15px !important;
        }
    }

    @media (min-width: 1080px) {
        #div-register-passkey {
            width: 1000px;
        }
    }

    @media (min-width: 1200px) {
        #div-register-passkey {
            width: 1140px;
        }
    }
</style>
